export function formatVersionHash(hash: string | null, length = 8): string {
  if (!hash) {
    return 'unknown';
  }
  return hash.substring(0, length);
}

export function hasVersionChanged(
  hash1: string | null,
  hash2: string | null
): boolean {
  if (!hash1 || !hash2) {
    return false;
  }
  return hash1 !== hash2;
}

export function formatRelativeTime(date: Date | null): string {
  if (!date) {
    return 'nie';
  }

  const now = new Date();
  const diffMs = now.getTime() - date.getTime();
  const diffSeconds = Math.floor(diffMs / 1000);
  const diffMinutes = Math.floor(diffSeconds / 60);
  const diffHours = Math.floor(diffMinutes / 60);
  const diffDays = Math.floor(diffHours / 24);

  if (diffSeconds < 60) {
    return 'gerade eben';
  } else if (diffMinutes < 60) {
    return `vor ${diffMinutes} Minute${diffMinutes !== 1 ? 'n' : ''}`;
  } else if (diffHours < 24) {
    return `vor ${diffHours} Stunde${diffHours !== 1 ? 'n' : ''}`;
  } else if (diffDays < 7) {
    return `vor ${diffDays} Tag${diffDays !== 1 ? 'en' : ''}`;
  } else {
    return date.toLocaleDateString('de-DE');
  }
}

export function getUpdateTooltipText(
  isAvailable: boolean,
  currentVersion: string | null,
  latestVersion: string | null
): string {
  if (!isAvailable) {
    return 'Keine Updates verfügbar';
  }

  if (currentVersion && latestVersion) {
    const current = formatVersionHash(currentVersion);
    const latest = formatVersionHash(latestVersion);
    return `Update verfügbar: ${current} → ${latest}`;
  }

  return 'Neue Version verfügbar';
}
